export default "/_next/static/chunks/fonts/GoudyOldStyleMT-Italic-f04e8f6373362190b51747bc16a5c309.ttf";